import Vue from 'vue'

function WrapperCell (components=[]) {
  const WrapperComponent = Vue.extend({
    methods: {
      onClick (e) {
        e.preventDefault()
        if (callback) {
          callback(this.params)
        }
      }
    },
    render(h) {
      return h('div', {
        class: '-wrapper h-center-'
      }, components.map(c => h(c, {
        props: {
          params: this.params
        }
      })))
    },
    beforeMount() {
      this.text = this.text || this.params.value
    }
  })
  return WrapperComponent
}

export default WrapperCell



// WEBPACK FOOTER //
// ./src/pages/components/ag-grid/WrapperCell.js